<template>
  <div
      class="home-row"
      :class="{ 'is-new': task.is_new && task.state === 'ready_to_test' }"
      role="button"
      tabindex="0"
      qid="home-task-row"
      @click="$emit('open', task)"
      @keydown.enter="$emit('open', task)"
  >
    <span class="home-row__dot" :class="'is-' + tag.color"></span>
    <div class="home-row__main">
      <div class="home-row__title">{{ title }}</div>
      <div class="home-row__context">{{ context }}</div>
    </div>
    <span
        v-if="task.new_messages"
        class="home-signal is-violet"
        v-b-tooltip.hover
        :title="$tc('home.signals.new_messages', task.new_messages, { count: task.new_messages })"
    >
      <font-awesome-icon icon="comment"/>{{ task.new_messages }}
    </span>
    <span
        v-if="task.files"
        class="home-signal"
        v-b-tooltip.hover
        :title="$tc('home.signals.files', task.files, { count: task.files })"
    >
      <font-awesome-icon icon="paperclip"/>{{ task.files }}
    </span>
    <span class="home-tag" :class="'is-' + tag.color">{{ tagLabel }}</span>
  </div>
</template>

<script>
import { taskTag, taskTitle } from '@/views/Home/homeTasks.js';

// One task in "My work"; the project, control objective or element and the due date are in the headings above it
export default {
  name: 'HomeTaskRow',
  props: {
    task: { type: Object, required: true }
  },
  computed: {
    title() {
      return taskTitle(this, this.task);
    },
    tag() {
      return taskTag(this.task);
    },
    tagLabel() {
      if (this.tag.key.indexOf('type_') === 0) {
        return this.$t('home.types.' + this.tag.key.substr(5));
      }
      return this.$t('home.tags.' + this.tag.key);
    },
    context() {
      if (this.task.kind === 'validation') {
        const validation = this.task.validation;
        return [this.$t('validations.checklist.' + validation.type), validation.created_by ? validation.created_by.name : null]
          .filter(Boolean).join(' · ');
      }
      return this.$t('home.states.' + this.task.state);
    }
  }
};
</script>
